import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  CustomPanel,
  PageHeader,
  CustomDataTableHeader,
  CustomCheckbox,
  Badge,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useCadastroStatusEtiquetaEstoque, { LOAD_MESSAGE } from './CadastroStatusEtiquetaEstoqueHook'
import StatusEtiquetaModal from './StatusEtiquetaModal/StatusEtiquetaModal'
import PalletAreaStatus from '../../../../constants/pallet-area-status'

function CadastroStatusEtiquetaEstoque({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useCadastroStatusEtiquetaEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET:
        dispatch(showLoadingBox('Carregando Status de Etiqueta', 'Aguarde...'))
        localDispatch.getStatusEtiqueta(selectedTp)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>8.21 - Cadastro Status Etiqueta - Estoque</PageHeader>

      <div style={{ marginTop: 20 }}>
        <CustomPanel
          showBtnNovo={!!selectedTp}
          onNovo={() => localDispatch.onBtnNovo()}
          onVoltar={history.goBack}
        >
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-12">
              <DataTable
                header={header}
                value={state.itens}
                paginator
                rows={15}
                selectionMode="single"
                onRowClick={e => localDispatch.onRowClick(e.data)}
                globalFilter={state.globalFilter}
                emptyMessage="Nenhum status cadastrado"
                dataKey="id"
              >
                <Column field="id" header="Código" style={{ width: 80 }} />
                <Column field="status" header="Status" />
                <Column
                  field="grupo"
                  header="Grupo"
                  style={tableCellCentered()}
                  body={utl => {
                    const status = PalletAreaStatus(utl.grupo)
                    return <Badge color={status.color}>{status.label}</Badge>
                  }}
                  bodyStyle={tableCellCentered()}
                />
                <Column
                  header="Ativo"
                  body={row => (
                    <CustomCheckbox disabled checked={!!row.active} onChange={() => {}} />
                  )}
                  bodyStyle={tableCellCentered()}
                  style={{ width: 120, textAlign: 'center' }}
                />
                <Column
                  header="Status Padrão"
                  body={row => (
                    <CustomCheckbox disabled checked={!!row.padrao} onChange={() => {}} />
                  )}
                  bodyStyle={tableCellCentered()}
                  style={{ width: 140, textAlign: 'center' }}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>

      <StatusEtiquetaModal
        show={state.modal.show}
        data={state.modal.data}
        itens={state.itens}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroStatusEtiquetaEstoque))
